/* Grouped Matrix – select-all, checkbox↔qty sync, steppers en submit-schoonmaak */
import { updateTotal } from './priceTotal.js';

function getMainForm() {
  return (
    document.querySelector('.single-product form[data-wc-main="1"]') ||
    document.querySelector('.single-product form.variations_form.cart') ||
    document.querySelector('.single-product form.cart')
  );
}

export function mount() {
  const forms = Array.from(document.querySelectorAll('form.wk-grouped-matrix'));
  if (!forms.length) return;

  forms.forEach((form) => {
    if (form.dataset.wkBound === '1') return;
    form.dataset.wkBound = '1';

    const rows    = Array.from(form.querySelectorAll('.wk-gm-row[data-cid]'));
    const toggler = form.querySelector('.wk-gm-toggle-all');

    function touchTotal() {
      // Altijd het HOOFDformulier laten herrekenen (ook als deze matrix niet-main is)
      const main = getMainForm();
      if (main) updateTotal(main);
    }

    function setRowState(row, on) {
      const cb  = row.querySelector('.wk-gm-check');
      const qty = row.querySelector('.wk-gm-qty');
      if (!cb || !qty || cb.disabled || qty.disabled) return;
      cb.checked = !!on;
      qty.value  = on ? (qty.value || qty.getAttribute('min') || '1') : '';
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      touchTotal();
    }

    // Checkbox ↔ qty sync
    rows.forEach((row) => {
      const cb  = row.querySelector('.wk-gm-check');
      const qty = row.querySelector('.wk-gm-qty');
      if (!cb || !qty) return;

      cb.addEventListener('change', () => setRowState(row, cb.checked));
      qty.addEventListener('input',  touchTotal);
      qty.addEventListener('change', touchTotal);
    });

    // Alles selecteren / deselecteren
    if (toggler) {
      toggler.addEventListener('click', () => {
        const state = toggler.getAttribute('data-state') === 'on';
        const next  = !state;
        rows.forEach((r) => setRowState(r, next));
        toggler.setAttribute('data-state', next ? 'on' : 'off');
        toggler.textContent = next ? 'Alles deselecteren' : 'Alles selecteren';
        touchTotal();
      });
    }

    // Submit: verwijder lege quantity[] zodat Woo niets post voor lege rijen
    form.addEventListener('submit', () => {
      form.querySelectorAll('.wk-gm-qty').forEach((el) => {
        if (!el.value || Number(el.value) <= 0) el.name = '';
      });
    });

    // Mini steppers
    rows.forEach((row) => {
      const wrap  = row.querySelector('.wk-gm-col--qty .quantity');
      const input = wrap?.querySelector('input.wk-gm-qty');
      if (!wrap || !input) return;
      if (wrap.querySelector('.qty-btn')) return;

      const minus = Object.assign(document.createElement('button'), { type: 'button', className: 'qty-btn', textContent: '−' });
      minus.setAttribute('aria-label', 'Minder');
      const plus  = Object.assign(document.createElement('button'), { type: 'button', className: 'qty-btn', textContent: '+' });
      plus.setAttribute('aria-label', 'Meer');

      wrap.prepend(minus); wrap.append(plus);

      const getNum = (el, attr, fallback) => {
        const n = Number(el.getAttribute(attr));
        return Number.isFinite(n) ? n : fallback;
      };

      wrap.addEventListener('click', (e) => {
        if (!e.target.classList.contains('qty-btn')) return;

        const step = getNum(input, 'step', 1);
        const min  = getNum(input, 'min', 0); // min 0 zodat deselect mogelijk blijft
        const maxA = input.getAttribute('max');
        const max  = maxA ? Number(maxA) : Infinity;

        let val = Number(input.value || (e.target === plus ? Math.max(1, min) : Math.max(0, min - step)));
        val += e.target === plus ? step : -step;
        val = Math.max(0, Math.min(max, val));

        input.value = val > 0 ? String(val) : '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        touchTotal();
      });
    });

    // Init
    touchTotal();
  });
}

export default { mount };
